import { render, staticRenderFns } from "./PaginationFooter.vue?vue&type=template&id=9d7d0c70"
import script from "./PaginationFooter.vue?vue&type=script&lang=js"
export * from "./PaginationFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports